// Checklist steps the model proposes for a task being created, or the reason it has none.
export class CopilotTaskChecklistSuggestions {
  steps: string[];

  message?: string;

  constructor() {
    this.steps = [];
  }
}
